export const valuesFields = {
  countryLabel: "info",
  countryValue: "info"
};

export const featureFields = {
  feature: "info",
  visible: "checkbox"
};

export const siteFields = {
  name: "info",
  country: "info"
};

export const legalRulesFields = {
  mon: "info",
  tue: "info",
  wed: "info",
  thu: "info",
  fri: "info",
  sat: "info",
  sun: "info",
  holidayThreshold: "info",
  validFrom: "info"
};

export const legalRulesActions = [
  {
    name: "new",
    functionName: "startAddingLegalConfiguration",
    fa: "fa-plus"
  }
];

export const legalRulesRowActions = [
  {
    name: "edit",
    functionName: "startEditingLegalRules",
    fa: "fa-pencil-alt"
  },
  {
    name: "delete",
    functionName: "startDeletingLegalRules",
    fa: "fa-trash"
  }
];

export const teamFields = {
  name: "info",
  serviceLine: "info",
  country: "info",
  profitCenter: "info",
  excludeFromProfitabilityReport: "info",
  archived: "boolean"
};

export const teamActions = [
  {
    name: "new",
    functionName: "startAddingTeam",
    fa: "fa-plus"
  },
  {
    name: "export",
    functionName: "exportTeams",
    fa: "fa-download"
  },
];

export const teamRowActions = [
  {
    name: "edit",
    functionName: "startEditingTeam",
    fa: "fa-pencil-alt"
  },
  {
    name: "view",
    functionName: "openTeam"
  },
  {
    name: "delete",
    functionName: "startDeletingTeam",
    fa: "fa-trash"
  }
];

export const clientFields = {
  name: "info",
  additionalInfo: "info",
  taxId: "info",
  mdpId: "info",
  mdpName: "info",
  country: "info",
  clientGroupName: "info",
  defaultBillingTypeName: "info"
};

export const clientWithProjectsFields = {
  name: "info",
  additionalInfo: "info",
  taxId: "info",
  mdpId: "info",
  mdpName: "info",
  country: "info",
  clientGroupName: "info",
  hasProjects: "checkbox",
  defaultBillingTypeName: "info"
};

export const clientActions = [
  {
    name: "new",
    functionName: "startAddingNewClient",
    fa: "fa-plus"
  }
];

export const clientRowActions = [
  {
    name: "edit",
    functionName: "startEditingClient",
    fa: "fa-pencil-alt"
  },
  {
    name: "delete",
    functionName: "startDeletingClient",
    fa: "fa-trash",
    tooltip: true
  },
  {
    name: 'download_client_notes',
    functionName: 'downloadClientNotes',
    fa: 'fa-download'
  }
];

export const clientWithProjectsRowActions = [
  {
    name: "view_projects",
    functionName: "viewProjects",
  },
  {
    name: "edit",
    functionName: "startEditingClient",
    fa: "fa-pencil-alt"
  },
  {
    name: "delete",
    functionName: "startDeletingClient",
    fa: "fa-trash",
    tooltip: true
  },
  {
    name: 'download_client_notes',
    functionName: 'downloadClientNotes',
    fa: 'fa-download'
  }
];

export const fields = {
  cannonicalName: 'info',
  name: "info",
  description: "info",
  // country: "info"
};

export const rowActions = [
  {
    name: "edit",
    functionName: "startEditingConfiguration",
    fa: "fa-pencil-alt"
  },
  {
    name: "processes",
    functionName: "openProcesses"
  }
];

export const interruptFields = {
  name: "info",
  description: "info",
  country: "info",
  hasServiceLine: "info",
  includeInReports: "info",
  hasClient: "info",
  hasValueAdded: "info"
};

export const interruptActions = [
  {
    name: "new",
    functionName: "startAddingNewInterrupt",
    fa: "fa-plus"
  }
];

export const interruptRowActions = [
  {
    name: "edit",
    functionName: "startEditingInterrupt",
    fa: "fa-pencil-alt"
  },
  {
    name: "delete",
    functionName: "startDeletingInterrupt",
    fa: "fa-trash"
  }
];

export const editCountryData = {
  country_name: {
    type: "text",
    editionDisabled: true
  },
  code: {
    type: "text",
    tooltip: true
  },
  currency_code: {
    type: "text",
    tooltip: true
  },
  projects_flag: {
    type: "select"
  }
};

export const newHolidayData = {
  date: {
    type: "date",
    tooltip: true
  },
  siteName: {
    type: "select"
  }
};

export const newSiteData = {
  name: {
    type: "text"
  },
  country: {
    type: "text",
    editionDisabled: true
  }
};

export const newLegalRuleData = {
  define: {
    tooltip: true
  },
  mon: {
    type: "number"
  },
  tue: {
    type: "number"
  },
  wed: {
    type: "number"
  },
  thu: {
    type: "number"
  },
  fri: {
    type: "number"
  },
  sat: {
    type: "number"
  },
  sun: {
    type: "number"
  },
  holidayThreshold: {
    type: "number"
  },
  subscriptionUsers: {
    type: "multiselect",
    tooltip: true
  },
  validFrom: {
    type: "date"
  }
};

export const defaultLegalRuleValues = {
  mon: 0,
  tue: 0,
  wed: 0,
  thu: 0,
  fri: 0,
  sat: 0,
  sun: 0,
  holidayThreshold: 0,
  subscriptionUsers: []
};

export const positionDialogCardWeekTable = {
  mon: true,
  tue: true,
  wed: true,
  thu: true,
  fri: true,
  sat: true,
  sun: true,
  holidayThreshold: true
};

export const newwTeamData = {
  name: {
    type: "text"
  },
  serviceLine: {
    type: "array"
  },
  profitCenterId: {
    type: "select"
  },
  excludeFromProfitabilityReport: {
    type: "checkbox",
    isNotRequired: true
  },
  country: {
    type: "text",
    editionDisabled: true
  }
};

export const editTeamData = {
  name: {
    type: "text"
  },
  serviceLine: {
    type: "array"
  },
  profitCenterId: {
    type: "select",
    isNotRequired: true
  },
  excludeFromProfitabilityReport: {
    type: "checkbox",
    isNotRequired: true
  },
  country: {
    type: "text",
    editionDisabled: true
  }
};

export const newClientData = {
  country: {
    type: "text",
    editionDisabled: true
  },
  name: {
    type: "text"
  },
  additionalInfo: {
    type: "text",
    tooltip: true,
    isNotRequired: true
  },
  taxId: {
    type: "text"
  },
  clientGroupId: {
    type: "select"
  },
  defaultBillingTypeId: {
    type: "select",
    isNotRequired: true
  },
  multiselectKeywords: {
    type: "toDoList",
    isNotRequired: true
  }
};

export const clientSelect = {
  clientGroupId: {
    valueToAdd: "id",
    valueToShow: "name"
  },
  defaultBillingTypeId: {
    valueToAdd: "id",
    valueToShow: "name"
  }
};

export const newConfigurationData = {
  name: {
    type: "text"
  },
  description: {
    type: "textarea"
  },
  processGroupId: {
    type: "select"
  }
};

export const configurationSelect = {
  processGroupId: {
    valueToAdd: "id",
    valueToShow: "name"
  }
};

export const editConfigurationData = {
  name: {
    type: "text"
  },
  description: {
    type: "textarea"
  },
  processGroupId: {
    type: "select",
    editionDisabled: true
  }
};

export const deleteConfigurationData = {
  name: {
    type: "text"
  },
  description: {
    type: "textarea"
  },
  country: {
    type: "text"
  },
  processGroupId: {
    type: "select"
  }
};

export const newInterruptData = {
  name: {
    type: "text"
  },
  description: {
    type: "textarea"
  },
  country: {
    type: "text",
    editionDisabled: true
  },
  interruptId: {
    type: "select"
  },
  includeInReports: {
    type: "checkbox",
    isNotRequired: true
  },
  hasServiceLine: {
    type: "checkbox",
    isNotRequired: true
  },
  hasClient: {
    type: "checkbox",
    isNotRequired: true
  },
  hasValueAdded: {
    type: "checkbox",
    isNotRequired: true
  }
};

export const interruptSelect = {
  interruptId: {
    valueToAdd: "id",
    valueToShow: "name"
  }
};

export const editInterruptData = {
  name: {
    type: "text",
    editionDisabled: true
  },
  description: {
    type: "textarea"
  },
  country: {
    type: "text",
    editionDisabled: true
  },
  interruptId: {
    type: "select",
    editionDisabled: true
  },
  includeInReports: {
    type: "checkbox",
    editionDisabled: true
  },
  hasServiceLine: {
    type: "checkbox",
    editionDisabled: true
  },
  hasClient: {
    type: "checkbox",
    editionDisabled: true
  },
  hasValueAdded: {
    type: "checkbox",
    editionDisabled: false,
    isNotRequired: true
  }
};

export const deleteInterruptData = {
  name: {
    type: "text"
  },
  description: {
    type: "textarea"
  },
  country: {
    type: "text"
  },
  interruptId: {
    type: "select"
  },
  includeInReports: {
    type: "checkbox"
  },
  hasServiceLine: {
    type: "checkbox"
  },
  hasClient: {
    type: "checkbox"
  },
  hasValueAdded: {
    type: "checkbox"
  }
};

export const newProblemData = {
  name: {
    type: "text"
  },
  description: {
    type: "textarea"
  }
};

export const problemFields = {
  name: "info",
  description: "info"
};

export const problemActions = [
  {
    name: "new",
    functionName: "startAdddingProblem",
    fa: "fa-plus"
  }
];

export const problemRowActions = [
  {
    name: "edit",
    functionName: "startEditingProblem",
    fa: "fa-pencil-alt"
  },
  {
    name: "delete",
    functionName: "startDeletingProblem",
    fa: "fa-trash"
  }
];

export const daysDictionary = {
  MONDAY: 'mon',
  TUESDAY: 'tue',
  WEDNESDAY: 'wed',
  THURSDAY: 'thu',
  FRIDAY: 'fri',
  SATURDAY: 'sat',
  SUNDAY: 'sun'
};

export const automationDashboardFields = {
  automationName: "info"
};

export const newTechnologyData = {
  automationName: {
    type: "text"
  }
};

export const automationDashboardActions = [
  {
    name: "new",
    functionName: "startAdddingTechnology",
    fa: "fa-plus"
  },
  {
    name: "export",
    functionName: "exportTechnology",
    fa: "fa-download"
  },
  {
    name: "historic_export",
    functionName: "startHistoricExport",
    fa: "fa-download"
  },
  {
    name: "historic_export_changes",
    functionName: "startHistoricExportChange",
    fa: "fa-download"
  }
];

export const automationDashboardRowActions = [
  {
    name: "edit",
    functionName: "startEditingTechnology",
    fa: "fa-pencil-alt"
  },
  {
    name: "delete",
    functionName: "startDeletingTechnology",
    fa: "fa-trash"
  }
];

export const historicExportData = {
  from: {
    type: "monthPicker"
  },
  to: {
    type: "monthPicker"
  }
};

export const waitingClientsFields = {
  name: "info",
  taxId: "info",
  clientStatus: "info",
  fromMdp: "checkbox",
  potentialDuplicates: "info"
};

export const waitingClientsRowActions = [
  {
    name: "accept",
    functionName: "acceptWaitingClient",
    fa: "fa-plus"
  },
  {
    name: "edit_origin",
    functionName: "editOriginClient"
  },
  {
    name: "decline",
    functionName: "declineWaitingClients",
    fa: "fa-trash",
    off: (row) => row.clientStatus === 'Declined'
  }
];

export const waitingClientsGlobalActions = [
  {
    name: 'show_declined_clients',
    functionName: "toggleDeclinedClients"
  }
];

export const originClientToEditData = {
  client: {
    type: "select"
  }
};

export const originClientSelect = {
  client: {
    valueToAdd: "id",
    valueToShow: "name"
  }
};

export const overtimeRequestsAlertData = {
  language: {
    type: "radioSection",
    isNotRequired: true,
    options: [
      {
        name: "en",
        label: "EN",
        value: "en"
      },
      {
        name: "de",
        label: "DE",
        value: "de"
      }
    ]
  },
  teamId: {
    type: "select",
    isNotRequired: true
  },
  allTeams: {
    type: "checkbox",
    isNotRequired: true
  },
};

export const profitCentersFields = {
  name: "info",
  code : "info",
  description : "info",
  // country: "info"
};

export const profitCentersRowActions = [
  {
    name: "edit",
    functionName: "startEditingProfitCenter",
    fa: "fa-pencil-alt"
  },
  {
    name: "delete",
    functionName: "startDeletingProfitCenter",
    fa: "fa-trash"
  }
];

export const profitCentersGlobalActions = [
  {
    name: 'add_new_profit_center',
    functionName: "startAddingProfitCenter",
    fa: "fa-plus"
  }
];

export const newProfitCenterData = {
  name: {
    type: "text"
  },
  code: {
    type: "text"
  },
  description: {
    type: "textarea",
    isNotRequired: true
  },
  // country: {
  //   type: "text",
  //   editionDisabled: true
  // }
};


export const seniorityFields = {
  L01: "checkbox",
  L02: "checkbox",
  L03: "checkbox",
  L04: "checkbox",
  L05: "checkbox",
  L06: "checkbox",
  L07: "checkbox",
  L08: "checkbox",
  L09: "checkbox",
  L10: "checkbox"
};

export const seniorityActions = [
  {
    name: 'edit_seniority_levels',
    functionName: "startEditingSeniorityLevels",
    fa: "fa-pencil-alt"
  }
];
